import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  getSidebarNavigation,
  getDefaultHomePage,
} from "@helpers/checkPermission";
import Preloader from "./Preloader/Preloader";

/**
 * 用於僅有 :pagination 子路由、沒有 index 的模組：將 /module 導向權限內第一個可造訪子頁；
 * 若該模組完全無權限則導向 {@link getDefaultHomePage}。
 */
export default function ModuleHomeRedirect({ sidebarName }) {
  const navigate = useNavigate();
  const permissions = useSelector((s) => s.user.user.permissions);

  useEffect(() => {
    if (!permissions || typeof permissions !== "object") {
      return;
    }
    if (Object.keys(permissions).length === 0) {
      return;
    }
    const { allowed, path } = getSidebarNavigation(sidebarName, permissions);
    if (allowed && path) {
      navigate(path, { replace: true });
      return;
    }
    navigate(getDefaultHomePage(permissions), { replace: true });
  }, [sidebarName, permissions, navigate]);

  return <Preloader />;
}
